const initSearch = function () {
	// Header Search Button
	$('.ren-nav-search__button').on('click', function () {
		const $searchInput = $(this).siblings('.ren-nav-search__input');
		if (
			$searchInput.hasClass('ren-nav-search__input--active') &&
			$searchInput.val().trim()
		) {
			$searchInput.parent('form').on('submit');
		} else {
			$searchInput
				.toggleClass('ren-nav-search__input--active')
				.on('focus');
		}
	});
};

export default initSearch;
